




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '../store.vuex';
import { User } from '../models/userdata/userdto';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import router from '../router';
import { UserParams } from '@/models/userdata/userparams';
import { countries } from './Commons/phone-code-countries';
import FindJobsLink from './Registration/FindJobsLink.vue';
import Container from './Registration/Container.vue';
import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import SignupFooter from './Registration/SignupFooter.vue';
import AppSignupFooter from './Registration/AppSignupFooter.vue';
import SignupForm from './Registration/SignupForm.vue';
import TermsAndConditionModal from '@/components/Commons/TermsAndConditionModal.vue';
declare var window: any;

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 20000,
});

@Component({
  name: 'Signup',
  components: {
    FindJobsLink,
    Container,
    RegistrationCard,
    CardHeader,
    SignupFooter,
    AppSignupFooter,
    SignupForm,
    TermsAndConditionModal,
  },
})
export default class Signup extends Vue {
  $wlToastr: any;
  private wlUser: User = new User();
  private userParams: UserParams = new UserParams();
  private areaCode: string = '';
  private confirmPassword: string = '';
  private errorString: string = '';
  private socialRegistration: boolean = false;
  private socialRegistrationType: string = '';
  private userDeviceAppTkn: string = '';
  private countryCode: string = '';
  private candidatePhone: string = '';
  private translations = {
    countrySelectorLabel: null,
    countrySelectorError: null,
    phoneNumberLabel: null,
    example: null,
  };
  private noExample: boolean = true;
  private noFlags: boolean = true;
  private isEmailSystemGenerated: boolean = true;
  private errors = {
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: '',
  };

  get tagLine() {
    return vxm.configs.getGlobalConfigValue('WL_COMPANY_TAG_LINE')
  }

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.wlUser.phone =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.wlUser.phoneNumberValid = event.isValid;
  }

  get isPartialSignup() {
    return vxm.users.isPartialSignup;
  }
  get globalRefCode() {
    const RefCode = vxm.referrals.globalRefCode;
    console.log('RefCode', [RefCode]);
    this.wlUser.referralUrl = RefCode;
    return RefCode;
  }
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  googleLogin() {
    this.setOAuthProvider('google');
    this.setOAuthRegistrationType('google-register');
    return vxm.users.loginWithGoogle();
  }

  facebookLogin() {
    this.setOAuthProvider('facebook');
    this.setOAuthRegistrationType('facebook-register');
    return vxm.users.loginWithFacebook();
  }

  linkedinLogin() {
    this.setOAuthProvider('linkedin');
    this.setOAuthRegistrationType('linkedin-register');
    return vxm.users.loginWithLinkedin();
  }

  setOAuthProvider(provider: string) {
    this.$cookies.set('OAuthProvider', provider, 300);
  }

  setOAuthRegistrationType(rtype: string) {
    this.$cookies.set('OAuthRegistrationType', rtype, 300);
  }

  getOAuthProvider(): string {
    return this.$cookies.get('OAuthProvider');
  }

  getOAuthRegistrationType(): string {
    return this.$cookies.get('OAuthRegistrationType');
  }

  onAcceptTermsAndCondition() {
    this.$bvModal.hide('terms-service-modal');
    if (this.socialRegistrationType === 'facebook') {
      this.registerFacebook();
    } else if (this.socialRegistrationType === 'google') {
      this.registerGoogle();
    } else if (this.socialRegistrationType === 'linkedin') {
      this.registerLinkedIn();
    } else {
      this.sendRegistrationData();
    }
  }

  showTermsAndConditionPopup() {
    this.$bvModal.show('terms-service-modal');
  }

  register(confirmPassword) {
    const vm = this;
    if (vm.wlUser.firstName) {
      vm.wlUser.firstName = vm.wlUser.firstName.trim();
    }
    if (vm.wlUser.lastName) {
      vm.wlUser.lastName = vm.wlUser.lastName.trim();
    }
    vm.userParams.firstName = vm.wlUser.firstName;
    vm.userParams.lastName = vm.wlUser.lastName;
    vm.userParams.phone = vm.wlUser.phone;
    vm.userParams.password = vm.wlUser.password;
    this.wlUser.completeRegistration = this.socialRegistration;
    vxm.users.setUserParams(this.userParams);
    if (vm.socialRegistrationType === 'facebook') {
      this.userParams.isSocialMediaSignup = true;
      this.userParams.socialMediaType = 'facebook';
      this.userParams.email = this.wlUser.email;
      vxm.users.setUserParams(this.userParams);
      if (!vm.validateOAuthRegistrationData(vm.wlUser)) {
        this.$wlToastr('error', this.$t(this.errorString), 'Sign up');
        return;
      }
      // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
      if (false) {
        this.showTermsAndConditionPopup();
        return;
      }
      vm.registerFacebook();
      return;
    }
    if (vm.socialRegistrationType === 'google') {
      this.userParams.isSocialMediaSignup = true;
      this.userParams.socialMediaType = 'google';
      this.userParams.email = this.wlUser.email;
      vxm.users.setUserParams(this.userParams);
      if (!vm.validateOAuthRegistrationData(vm.wlUser)) {
        this.$wlToastr('error', this.$t(this.errorString), 'Sign up');
        return;
      }
      // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
      if (false) {
        this.showTermsAndConditionPopup();
        return;
      }
      vm.registerGoogle();
      return;
    }
    if (vm.socialRegistrationType === 'linkedin') {
      this.userParams.isSocialMediaSignup = true;
      this.userParams.socialMediaType = 'linkedin';
      this.userParams.email = this.wlUser.email;
      vxm.users.setUserParams(this.userParams);
      if (!vm.validateOAuthRegistrationData(vm.wlUser)) {
        this.$wlToastr('error', this.$t(this.errorString), 'Sign up');
        return;
      }
      // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
      if (false) {
        this.showTermsAndConditionPopup();
        return;
      }
      vm.registerLinkedIn();
      return;
    }
    if (!vm.validateRegistrationData(vm.wlUser, confirmPassword)) {
      this.$wlToastr('error', this.$t(this.errorString), 'Sign up');
      return;
    }
    // Feature was there to display terms of service modal while signup in JNP JTP. Currently they are not a customer
    if (false) {
      this.showTermsAndConditionPopup();
      return;
    }
    this.sendRegistrationData();
  }

  sendRegistrationData() {
    const vm = this;
    const respPromise: any = vxm.users.registerUser(vm.wlUser);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'AppRetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          if (vxm.users.UserDeviceAppTkn && errorMessageText.includes('/forgot-password?email=')) {
            let errorMessageText = "This email address is already in use. If this belongs to you, Please try Forgot password?"
            vm.$wlToastr('error', errorMessageText, 'Sign Up');
            setTimeout(() => {
              const appurl = '/atsuser/regSuccess?success=false';
              (<any>window).location = appurl
            },10000);
            return;
          }
          vm.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        const successMessage = values[0].successMessage;
        vm.$wlToastr('success', successMessage, 'Sign Up');
        if (vm.wlUser.userDeviceAppTkn) {
          router.push({
            name: 'AppVerification',
            query: {
              userDeviceToken: vm.wlUser.userDeviceAppTkn,
              userid: vm.wlUser.email,
            },
          });
        } else {
          router.push({ name: 'AppVerification' });
        }
      }
    });
  }

  registerFacebook() {
    const vm = this;
    const respPromise: any = vxm.users.registerFacebookUser(vm.wlUser);
    Promise.all([respPromise]).then((values) => {
      console.log([values]);
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'AppRetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          vm.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        const successMessage = values[0].successMessage;
        vm.$wlToastr('success', successMessage, 'Sign Up');
        if (vm.wlUser.userDeviceAppTkn) {
          router.push({
            name: 'AppVerification',
            query: {
              userDeviceToken: vm.wlUser.userDeviceAppTkn,
              userid: vm.wlUser.email,
            },
          });
        } else {
          router.push({ name: 'AppVerification' });
        }
      }
    });
  }

  registerGoogle() {
    const vm = this;
    console.log('user -- ', [vm.wlUser]);
    const respPromise: any = vxm.users.registerGoogleUser(vm.wlUser);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'AppRetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          vm.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        const successMessage = values[0].successMessage;
        vm.$wlToastr('success', successMessage, 'Sign Up');
        if (vm.wlUser.userDeviceAppTkn) {
          router.push({
            name: 'AppVerification',
            query: {
              userDeviceToken: vm.wlUser.userDeviceAppTkn,
              userid: vm.wlUser.email,
            },
          });
        } else {
          router.push({ name: 'AppVerification' });
        }
      }
    });
  }

  registerLinkedIn() {
    const vm = this;
    console.log('user -- ', [vm.wlUser]);
    const respPromise: any = vxm.users.registerLinkedInUser(vm.wlUser);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        if (values[0].errorCode === 'Phone Linked With Another Email') {
          router.push({ name: 'AppRetrieveOldEmailConfirmation' });
        } else {
          const errorMessageText = values[0].errorMessage;
          vm.$wlToastr('error', errorMessageText, 'Sign Up');
        }
      } else {
        const successMessage = values[0].successMessage;
        vm.$wlToastr('success', successMessage, 'Sign Up');
        if (vm.wlUser.userDeviceAppTkn) {
          router.push({
            name: 'AppVerification',
            query: {
              userDeviceToken: vm.wlUser.userDeviceAppTkn,
              userid: vm.wlUser.email,
            },
          });
        } else {
          router.push({ name: 'AppVerification' });
        }
      }
    });
  }

  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }

  get duplicateCheckRequired() {
    console.log(vxm.users.UserParams.checkForDuplicate);
    return vxm.users.UserParams.checkForDuplicate;
  }

  mounted() {
    this.countryCode = this.getCompanyCountryCode();
    vxm.utility.setAppWebView(true);
    const vm = this;
    this.userDeviceAppTkn = this.$route.query.token + '';
    vxm.users.setUserDeviceAppTkn(
      this.$route.query.token ? String(this.$route.query.token) : '',
    );
    console.log('token', [this.userDeviceAppTkn]);
    if (this.userDeviceAppTkn) {
      const respPromise: any = vxm.users.initAppRegisteredUser(
        this.userDeviceAppTkn,
      );
      Promise.all([respPromise]).then((values) => {
        const profile = values[0].data;

        console.log('profile..', [profile]);
        this.wlUser.userName = profile.email;
        this.wlUser.firstName = profile.firstName;
        this.wlUser.lastName = profile.lastName;
        this.wlUser.email = profile.email;
        this.wlUser.password = '';
        this.wlUser.phone = profile.phoneNum;
        this.wlUser.referralCode =
          profile.referralCode == null ? '' : profile.referralCode;
        this.wlUser.sourceType =
          profile.sourceType == null ? '' : profile.sourceType;
        this.wlUser.userDeviceAppTkn =
          profile.userDeviceAppTkn == null ? '' : profile.userDeviceAppTkn;
        this.setOAuthProvider(profile.sourceType);
        if (profile.sourceType === 'google') {
          this.socialRegistration = true;
          this.socialRegistrationType = 'google';
        }
        if (profile.sourceType === 'facebook') {
          this.socialRegistration = true;
          this.socialRegistrationType = 'facebook';
        }
        if (profile.sourceType === 'linkedin') {
          this.socialRegistration = true;
          this.socialRegistrationType = 'linkedin';
        }
        if (profile.sourceType === 'email') {
          this.socialRegistration = false;
          this.socialRegistrationType = 'email';
        }
        //if redirected from verify retrieved email
        if (vxm.users.UserParams.populateSignupPage) {
          let userParams = vxm.users.UserParams;
          console.log('populating values in signup page', userParams);
          vm.wlUser.firstName = userParams.firstName;
          vm.wlUser.lastName = userParams.lastName;
          vm.wlUser.email = userParams.email;
          vm.wlUser.phone = userParams.phone;
          vm.wlUser.password = userParams.password;
          vm.confirmPassword = userParams.password;
          vm.wlUser.duplicateCheckRequired = this.duplicateCheckRequired;
          vm.countryCode = vm.getCompanyCountryCode();
          vm.candidatePhone = userParams.phone.substring(
            userParams.phone.indexOf(' ') + 1,
          );
          let dialCode = userParams.phone.substring(
            1,
            userParams.phone.indexOf(' '),
          );
          for (var i = 0; i < countries.length; i++) {
            if (countries[i].dialCode === dialCode) {
              this.countryCode = countries[i].iso2;
            }
          }
        }
        vxm.referrals.setGlobalRefCode(this.wlUser.referralCode);
        //  }
      });
    }

    if (this.getOAuthRegistrationType() === 'google-register') {
      this.socialRegistration = true;
      this.socialRegistrationType = 'google';
      this.setOAuthRegistrationType('');
    }

    if (this.getOAuthRegistrationType() === 'facebook-register') {
      this.socialRegistration = true;
      this.socialRegistrationType = 'facebook';
      this.setOAuthRegistrationType('');
    }

    if (this.getOAuthRegistrationType() === 'linkedin-register') {
      this.socialRegistration = true;
      this.socialRegistrationType = 'linkedin';
      this.setOAuthRegistrationType('');
    }

    //if redirected from verify retrieved email
    if (vxm.users.UserParams.populateSignupPage) {
      let userParams = vxm.users.UserParams;
      console.log('populating values in signup page', userParams);
      vm.wlUser.firstName = userParams.firstName;
      vm.wlUser.lastName = userParams.lastName;
      vm.wlUser.phone = userParams.phone;
      vm.wlUser.password = userParams.password;
      vm.confirmPassword = userParams.password;
      vm.wlUser.duplicateCheckRequired = this.duplicateCheckRequired;
      vm.countryCode = vm.getCompanyCountryCode();
      vm.candidatePhone = userParams.phone.substring(
        userParams.phone.indexOf(' ') + 1,
      );
      let dialCode = userParams.phone.substring(
        1,
        userParams.phone.indexOf(' '),
      );
      for (var i = 0; i < countries.length; i++) {
        if (countries[i].dialCode === dialCode) {
          this.countryCode = countries[i].iso2;
        }
      }
    }
  }
  validateRegistrationData(user: User, confirmPassword): boolean {
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!user.firstName) {
      this.errorString = 'signup.firstname.required';
      return false;
    }

    if (!user.lastName) {
      this.errorString = 'signup.lastname.required';
      return false;
    }

    if (!user.email) {
      this.errorString = 'signup.email.required';
      return false;
    }

    if (!user.email.match(emailformat)) {
      this.errorString = 'signup.enter.valid.email';
      return false;
    }

    if (!user.phone) {
      this.errorString = 'signup.phone.required';
      return false;
    }
    if (!user.phoneNumberValid) {
      this.errorString = 'signup.phone.valid';
      return false;
    }
    if (!user.password) {
      this.errorString = 'signup.password.required';
      return false;
    }

    const hasNumber = user.password.match(/\d+/g);
    const hasLetter = user.password.match(/[a-zA-Z]/g);
    const hasUpperCase = user.password.match(/[A-Z]/g);
    const hasSpecialCharacter = user.password.match(/[*@!#%&()^~{}]+/g);

    if (
      user.password.length <
        vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH') ||
      (hasNumber == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS')) ||
      hasLetter == null ||
      (hasUpperCase == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS')) ||
      (hasSpecialCharacter == null &&
        !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS'))
    ) {
      this.errorString = vxm.utility.passwordConditions;
      return false;
    }

    if (user.password !== confirmPassword) {
      this.errorString = 'signup.password.confirmation.equivalent';
      return false;
    }

    return true;
  }

  validateOAuthRegistrationData(user: User): boolean {
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!user.firstName) {
      this.errorString = 'signup.firstname.required';
      return false;
    }

    if (!user.lastName) {
      this.errorString = 'signup.lastname.required';
      return false;
    }

    if (!user.email) {
      this.errorString = 'signup.email.required';
      return false;
    }

    if (!user.email.match(emailformat)) {
      this.errorString = 'signup.enter.valid.email';
      return false;
    }

    if (!user.phone) {
      this.errorString = 'Phone number is required!';
      return false;
    }
    if (user.phone.length < 10) {
      this.errorString = 'signup.phone.valid';
      return false;
    }

    return true;
  }

  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }

  getCompanyCountryCode(): string {
    return vxm.jobs.getCompanyCountryCode;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }
}
